// @flow
import React from 'react';
import LogoLoginEL from "../../../assets/images/logo/logoLoginEL";
import LogoLoginEN from "../../../assets/images/logo/logoLoginEN";
import useUserData from "../../../hooks/user/useUserData";

type Props = {

};

const Logo = (props: Props) => {
	const {language} = useUserData();
	return language === `en` ? <LogoLoginEN width={props.width? props.width: 198} height={props.height? props.height : 81}/> : <LogoLoginEL width={props.width? props.width: 198} height={props.height? props.height : 81}/>
};

export default Logo